<div genTooltip  
    [tooltipShow]="!launchPacsEnabled" 
    [tooltipHtml]="'PACS Launch is unavailable'">
  <gen-button
    [text]="'Launch PACS'| stringTranslate"
    [disabled]="!launchPacsEnabled"
    [type]="'secondary'"
    (click)="launchPacs()">
  </gen-button>
</div>